var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification-message"},[_c('h2',{staticClass:"notification-message__title"},[_c('span',{staticClass:"notification-message__lang-icon"},[_vm._v(_vm._s(_vm.lang))]),_vm._v(" Текст уведомления ")]),_c('div',{staticClass:"notification-message__text",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }